export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_709_DATE_RANGE': 'Date Range',
    '_133_PULSE': 'Pulse',
    '_708_WELCOME_BACK__NAME_': 'Welcome back {{name}}!'
};
